import { ACT_CHANGE_LANGUAGE, SET_SOMETHING } from "./types";

export default {
  [ACT_CHANGE_LANGUAGE]({ commit }) {
    commit(SET_SOMETHING, "change renew name");
  },
};
